module.exports = __webpack_public_path__ + "static/universal-support.4bad0dc2.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/financing/universal-support.png
// module id = 989
// module chunks = 2